import { CampaignBody } from "@vviinn/user-managment-client-ts";

import { HandleChangeValue } from "../../types";
import { handleTextSearchConfig } from "../../textSearch/handleTextSearchConfig";
import { TextSearchNumbericTitlesKey } from "../../textSearch/types";
import { textSearchSettingsTitles } from "../../textSearch/constants";
import { parseNumberOrZero } from "../../../helpers";

export const calculateNewConfig = (
  isNumberSettings: boolean,
  config: CampaignBody,
  key: keyof CampaignBody | TextSearchNumbericTitlesKey,
  value: HandleChangeValue,
  oldValue?: HandleChangeValue,
): CampaignBody => {
  let newValue = isNumberSettings ? parseNumberOrZero(String(value)) : value;

  const isSameValue = oldValue === newValue || (!oldValue && !newValue);

  let newConfig = { ...config };
  if (key in textSearchSettingsTitles) {
    newConfig = handleTextSearchConfig(
      newConfig,
      key as TextSearchNumbericTitlesKey,
      isSameValue,
      newValue,
    );
  } else {
    if (isSameValue) {
      delete newConfig[key as keyof CampaignBody];
    } else
      newConfig = {
        ...newConfig,
        [key]: newValue,
      };
  }

  Object.keys(newConfig).forEach((key) => {
    const configKey = key as keyof CampaignBody;
    if (
      newConfig[configKey] === undefined ||
      (typeof newConfig[configKey] === "object" &&
        Object.keys(newConfig[configKey]).length === 0)
    ) {
      delete newConfig[configKey];
    }
  });
  return newConfig;
};
